module.exports = __webpack_public_path__ + "ad12d894c31fcffb7dc51122337a5830.svg";